import { render } from "./AddressBookTable.vue?vue&type=template&id=0374f1c4&scoped=true"
import script from "./AddressBookTable.vue?vue&type=script&lang=js"
export * from "./AddressBookTable.vue?vue&type=script&lang=js"

import "./AddressBookTable.vue?vue&type=style&index=0&id=0374f1c4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0374f1c4"]])

export default __exports__